import { createSlice } from '@reduxjs/toolkit';
import { Truck01, SwitchHorizontal01, Container, PackagePlus, MarkerPin04, LayersThree02 } from '@untitled-ui/icons-react/build/cjs';

const steps = [
    {
        id: 1,
        key: 'add-quote-details',
        title: 'Add Quote Details',
        description: 'Set up quote basics',
        formTitile: 'Add Quote Details',
        formDescription: 'Set up the basic details for your quote',
        icon: PackagePlus,
        component: null, // Will be set later
    },
    {
        id: 2,
        key: 'shipper-consignee-details',
        title: 'Shipper & Consignee',
        description: 'Pickup and Delivery Information',
        formTitile: 'Add Shipper and Consignee Details',
        formDescription: 'Enter the address information for both shipper and consignee',
        icon: MarkerPin04,
        component: null, // Will be set later
        headerBtn: {
            text: 'Swap Addresses',
            icon: SwitchHorizontal01,
        },
    },
    {
        id: 3,
        key: 'add-dimensions',
        title: 'Add Dimensions',
        description: 'Provide shipment dimensions',
        formTitile: 'Dimensions & Visualizations',
        formDescription: 'Provide package dimensions to calculate volume and weight',
        icon: LayersThree02,
        component: null, // Will be set later
        headerBtn: {
            text: 'Visualize Trailer',
            icon: Container,
        },
    },
    {
        id: 4,
        key: 'set-shipment-details',
        title: 'Set Shipment Details',
        description: 'Package details and extras',
        formTitile: 'Set Shipment Details',
        formDescription: 'Add essential shipment information for processing',
        icon: Truck01,
        component: null, // Will be set later
    },
];

const initialState = {
    steps,
    currentStep: 1,
    formData: {
        step_1: {
            classification: '',
            urgency: '',
            pickupDate: '',
            pickupSensitivity: '',
            pickupTimeFrame: '',
            deliveryDate: '',
            deliverySensitivity: '',
        },
        step_2: {
            shipperId: null,
            shipperCompanyName: '',
            shipperFullAddress: '',
            shipperAddress1: '',
            shipperStreetNumber: '',
            shipperCity: '',
            shipperState: '',
            shipperCountry: '',
            shipperPostal: '',
            shipperLatitude: '',
            shipperLongitude: '',
            shipperStateCode: '',
            shipperCountryCode: '',
            consigneeId: null,
            consigneeCompanyName: '',
            consigneeFullAddress: '',
            consigneeAddress1: '',
            consigneeStreetNumber: '',
            consigneeCity: '',
            consigneeState: '',
            consigneeCountry: '',
            consigneePostal: '',
            consigneeLatitude: '',
            consigneeLongitude: '',
            consigneeStateCode: '',
            consigneeCountryCode: '',
        },
        step_3: {
            linearFootage: 0,
            totalWeight: 0,
            dimensions: [],
            services: {
                serviceId: '',
                limitedAccess: false,
                inbond: false,
                dangerousGoods: false,
                inbondType: '',
                inbondName: '',
                inbondAddress: '',
                inbondContactMethod: '',
                inbondContactValue: '',
                dangerGoodsType: '',
                goodsClass: '',
                description: '',
                unitedNationsNumber: '',
                packagingGroup: '',
                emergencyContactName: '',
                emergencyContactNumber: '',
                emergencyContactExt: '',
                emergencyEapnbr: '',
            },
        },
        step_4: {
            primaryEquipmentType: '',
            secondaryEquipmentTypes: '',
            primaryEquipmentTypeFullName: '',
            secondaryEquipmentTypeFullNames: '',
        },
    },
};

export const QuotingFormSlice = createSlice({
    name: 'quotingForm',
    initialState,
    reducers: {
        setCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
    },
});

export const { setCurrentStep } = QuotingFormSlice.actions;
export default QuotingFormSlice.reducer;
